import classNames from "classnames";
import React from "react";
import styles from "./double-loader-scss.js";
const d = "M-4.4 6.07A7.5 7.5 0 1 0 0-7.5";
const DoubleLoader = ({
  className,
  topArcClassName,
  bottomArcClassName
}) => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "-9 -9 18 18",
      className: classNames(styles.wrapper, className)
    },
    /* @__PURE__ */ React.createElement("path", { className: classNames(styles.top, topArcClassName), strokeWidth: "3", d }),
    /* @__PURE__ */ React.createElement("path", { className: classNames(styles.bottom, bottomArcClassName), strokeWidth: "3", d })
  );
};
export {
  DoubleLoader
};
//# sourceMappingURL=double-loader.js.map
